import { useFeatureFlags } from '../contexts/FeatureFlagsContext';

/**
 * Hook simplifié - lit depuis le contexte global
 * Plus d'appel API, plus de loading !
 */
export const useFeatureFlag = (featureName) => {
  const { isEnabled } = useFeatureFlags();
  
  return {
    isEnabled: isEnabled(featureName),
    loading: false // Toujours false car déjà chargé au démarrage
  };
};

export default useFeatureFlag;